import angular from 'angular';
import {
  amDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-recommendation-document-dialog.controller';
import template from './edit-recommendation-document-dialog.html';
import amRecommendationDocumentNameMessagesTpl from './messages/am-recommendation-document.name.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

class dialogService {
  getOptions($event, {
    recommendationId,
    document
  }) {
    return {
      controller,
      controllerAs: 'editRecommendationDocumentDialogVM',
      locals: {
        recommendationId,
        document,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.am.editRecommendationDocumentDialog', [
  alerts,
  amDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('editRecommendationDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('am-recommendation-document.name.messages.html', amRecommendationDocumentNameMessagesTpl);
  })
  .name;
